/**
 * These are options to be exported to pages for users to input their accounts
 * MAKE SURE INDICES LINE UP 
 */
export const hospitalDisplayOptions = [
  'Kingston General Hospital',
  'Princess Margaret Hospital'
]

export const hospitalValueOptions = [
  'kingstonGeneralHospital',
  'princessMargaretHospital'
]

export const departmentDisplayOptions = [
  'Department of Oncology',
]

export const departmentValueOptions = [
  'departmentOfOncology',
]

export const specializationDisplayOptions = [
  'Radiation Oncology',
]

export const specializationValueOptions = [
  'radiationOncology',
]

{/* <option value="radiationOncology">Radiation Oncology</option> */}
{/* <option value="departmentOfOncology">Department of Oncology</option> */}

{/* <option value="kingstonGeneralHospital">Kingston General Hospital</option>
                <option value="princessMargaretHospital">Princess Margaret Hospital</option> */}